import posthog from 'posthog-js';

const sanitizeBoosts = <T>(boosts: unknown, source: string): T[] | null => {
  if (boosts == null) {
    return boosts as null;
  }

  if (!Array.isArray(boosts)) {
    posthog.capture('boosts_payload_invalid', {
      source,
      reason: 'not_an_array',
      received_type: typeof boosts,
    });

    return [];
  }

  const invalidIndexes: number[] = [];
  const filtered = boosts.filter((item, index) => {
    if (item == null) {
      invalidIndexes.push(index);

      return false;
    }

    return true;
  }) as T[];

  if (invalidIndexes.length > 0) {
    posthog.capture('boosts_payload_invalid', {
      source,
      reason: 'contains_nullish',
      original_length: boosts.length,
      filtered_length: filtered.length,
      invalid_count: invalidIndexes.length,
      invalid_indexes: invalidIndexes.slice(0, 10),
    });
  }

  return filtered;
};

export { sanitizeBoosts };
